export declare const RangeInputWithLabelComposite: any;
